import React from 'react';
import MyText from './MyText';
import arrow from '../assets/arrow.svg';

export default function LocalitaSelect(props){

    const _removeDuplicates = (arr) => {
        if(!arr || !arr[0] || !arr[0].code) return arr;
        return arr.filter((v,i,a)=>a.findIndex(t=>(t.code === v.code))===i)
    }
    const data = props.data ? _removeDuplicates(props.data) : [];

    return (
        <div style={{...styles.container, ...props.containerStyle}}>
            <MyText style={{...styles.label, ...props.labelStyle}}>{props.label}</MyText>
            <input 
                list={props.idList}
                value={props.value} 
                onChange={props.onChange}
                style={{...styles.select, ...props.selectStyle}}
                className='customSelect'
            />
            <datalist id={props.idList}>
                {data.map((x) => (
                    <option key={x.code} value={x.code} style={{...styles.label, ...props.labelStyle}}>
                        {x.name}
                    </option>
                ))}
            </datalist>
            <img src={arrow} alt={"arrow"} style={styles.arrow}/>
        </div>
    );
};
const styles = {
    container:{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    select:{
        height: 46,
        borderRadius: 10,
        border: 'none',
        padding: '0 1rem',
        boxShadow: '0px 4px 4px 0px #0000000D',
        appearance: 'none',
        cursor: 'pointer',
        marginBottom: '-30px',
    },
    label:{
        fontSize: '1.2rem',
    },
    arrow:{
        // width: '100%',
        position: 'relative',
        right: 'calc(-100% + 35px)',
        top: '-15px',
        width: 20,
        height: 20,
        cursor: 'pointer',
        pointerEvents: 'none'
        // zIndex: 10,
    }
}